import axios from "@/plugins/axios";

let url = "/api/v1/me";

import bookmarks from "./bookmarks";
import files from "./files";
import likes from "./likes";
import * as points from "./points";

export default {
    bookmarks,
    files,
    likes,
    ...points,

    get() {
        return axios.get(url).then((result) => result.data);
    },
    put(data) {
        return axios.put(url, data).then((result) => result.data);
    },
    checkPassword(data) {
        return axios.put(`${url}/check-password`, data).then((result) => result.data);
    },
    withdraw(data) {
        return axios.post(`${url}/withdraw`, data).then((result) => result.data);
    },
};
